module.exports = __webpack_public_path__ + "img/home-1-texture.108ab78b.png";